import { IDuTruHocBongRequest } from "../../../model/request/bao-cao/IDuTruHocBongRequest";
import {
  IDuTruHocBongKetQua,
  ITyLeHocBong,
} from "../../../model/respone/bao-cao/IDuTruHocBong";
import { IDuTruHocBongActionTypes } from "../../action-types/bao-cao/IDuTruHocBongActions";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { IDuTruHocBongReducer } from "../../reducer-model/bao-cao/IDuTruHocBongReducer";

const iniState: IDuTruHocBongReducer = {
  status: eReducerStatusBase.is_not_initialization,
  statusExport: eReducerStatusBase.is_completed,
  request: {
    hoc_ky: 0,
    nam_hoc: "",
    id_thu_chis: [],
    // Chưa thiết lập gì thì tính theo HỌC PHÍ (khoản rỗng = mọi khoản có cờ học phí) và chỉ
    // tính HỌC ĐI (0) — đúng cách trường vẫn làm trước nay.
    tinh_chat_hocs: [0],
    id_hes: [],
    id_khoas: [],
    khoa_hocs: [],
    id_nganhs: [],
    id_chuyen_nganhs: [],
    id_lops: [],
    nhom_theo: "nganh",
    moc_khoa_gop: 0,
    ty_le: null,
    hien_cot_hoc_phi: true,
    hien_cot_hoc_bong: true,
  },
};

export const duTruHocBongReducer = (
  state: IDuTruHocBongReducer = iniState,
  action: IDuTruHocBongActionTypes,
): IDuTruHocBongReducer => {
  switch (action.type) {
    case "DU_TRU_HOC_BONG_CHANGE_REQUEST": {
      return {
        ...state,
        request: {
          ...state.request,
          ...(action.payload as Partial<IDuTruHocBongRequest>),
        },
        // Đổi bộ lọc là phải dựng lại biểu; số liệu cũ để lại dễ đọc nhầm.
        status: eReducerStatusBase.is_need_reload,
      };
    }
    case "DU_TRU_HOC_BONG_LOAD_START":
      return { ...state, status: eReducerStatusBase.is_loading };
    case "DU_TRU_HOC_BONG_LOAD_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        ketQua: action.payload as IDuTruHocBongKetQua,
      };
    case "DU_TRU_HOC_BONG_LOAD_ERROR":
      // Lỗi thì coi như xong để bỏ vòng quay; thông báo đã bắn ở saga.
      return { ...state, status: eReducerStatusBase.is_completed };

    case "DU_TRU_HOC_BONG_LOAD_TY_LE_SUCCESS":
    case "DU_TRU_HOC_BONG_SAVE_TY_LE_SUCCESS": {
      const tyLe = action.payload as ITyLeHocBong | undefined;
      return {
        ...state,
        tyLeDaKhai: tyLe,
        // ★ KHÔNG đổ tỷ lệ vào request nữa: tỷ lệ chung nay là một Ô của BẢNG KHAI (dòng
        //   "Tất cả"), máy chủ tự lấy. Gửi kèm request chỉ làm hai nơi giữ cùng một số, sửa
        //   bảng xong màn hình vẫn tính theo số cũ.
        request: { ...state.request, ty_le: null },
        status:
          action.type === "DU_TRU_HOC_BONG_SAVE_TY_LE_SUCCESS"
            ? eReducerStatusBase.is_need_reload
            : state.status,
      };
    }

    case "DU_TRU_HOC_BONG_EXPORT_EXCEL_START":
    case "DU_TRU_HOC_BONG_XEM_TRUOC_START":
      return { ...state, statusExport: eReducerStatusBase.is_loading };
    case "DU_TRU_HOC_BONG_EXPORT_EXCEL_SUCCESS":
    case "DU_TRU_HOC_BONG_EXPORT_EXCEL_ERROR":
    case "DU_TRU_HOC_BONG_XEM_TRUOC_ERROR":
      return { ...state, statusExport: eReducerStatusBase.is_completed };
    case "DU_TRU_HOC_BONG_XEM_TRUOC_SUCCESS":
      return {
        ...state,
        statusExport: eReducerStatusBase.is_completed,
        printHtml: action.payload as string,
      };
    case "DU_TRU_HOC_BONG_DONG_XEM_TRUOC":
      return { ...state, printHtml: undefined };

    default:
      return state;
  }
};
